module.exports = __webpack_public_path__ + "img/VinoTintoRiojaVegaReserva.7bade9bc.jpg";